import api from './api';

// Giriş ekranının KENDİ adımını açtığı yanıtlar — toast'u interceptor değil sayfa taşır:
//  - 403 auth.passwordExpired → yeni şifre formu
//  - 403 auth.mfaRequired → doğrulama kodu adımı
//  - 403 auth.mfaEnrollmentRequired → iki adımlı doğrulama kurulumu
// Diğer tüm giriş hataları eskisi gibi toast'lanır.
export const LOGIN_SELF_HANDLED_ERRORS = ['auth.passwordExpired', 'auth.mfaRequired', 'auth.mfaEnrollmentRequired', 'auth.sso.required'];

export const login = (data) => api.post('/v1/auth/login', data, { skipErrorToast: LOGIN_SELF_HANDLED_ERRORS });
export const logout = (config) => api.post('/v1/auth/logout', {}, config);
export const getMe = () => api.get('/v1/auth/me');
export const switchTenant = (tenantId) => api.post('/v1/auth/switch-tenant', { tenantId });
export const setPassword = (data) => api.patch('/v1/auth/set-password', data);
export const requestOtp = (loginName) => api.get(`/v1/auth/otp?loginName=${encodeURIComponent(loginName)}`);
export const resetPassword = (data) => api.patch('/v1/auth/reset-password', data);
export const changeExpiredPassword = (data) => api.post('/v1/auth/change-expired-password', data);
export const getPasswordPolicy = (userId) => api.get(`/v1/auth/password-policy?userId=${encodeURIComponent(userId)}`);

// İki adımlı doğrulama — giriş sınamasının tamamlanması (oturum henüz yok).
export const verifyMfaChallenge = (data) => api.post('/v1/auth/mfa/verify', data);
export const resendMfaEnrollmentCode = (challengeToken) => api.post('/v1/auth/mfa/enroll/resend-code', { challengeToken });
export const verifyMfaEnrollmentEmail = (data) => api.post('/v1/auth/mfa/enroll/verify-email', data);
export const confirmMfaEnrollment = (data) => api.post('/v1/auth/mfa/enroll/confirm', data);

// Hareketsizlik penceresinin canlı tutma pingi (kullanıcı etkin ama istek atmıyorken).
export const keepAlive = () => api.post('/v1/auth/keepalive');
